// src/pages/ContactPage.js
import React from 'react';
import Contact from '../components/Contact'; // Assuming you moved the original to components

function ContactPage() {
    // No extra padding needed here as the Contact component has its own vertical centering
    return <Contact />;
}

export default ContactPage;